@let branding = brandingService.branding$ | async;

@if (branding !== null && branding !== undefined) {
    @if (isLearnerMissing) {
        <mm-profile-learner-missing></mm-profile-learner-missing>
    } @else {
        <mm-feedback class="mm-profile-feedback" *ngIf="feedbackPopupData!== undefined" [data]="feedbackPopupData"
                     [checkIfFeedbackAllow]="true"></mm-feedback>
    }
}
